import React from "react";
import { Disclosure } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons/faChevronUp";
import AccordionContent from "./AccordionContent";

let Icon = () => (
    <div className="flex items-center justify-center w-full py-10">
        <FontAwesomeIcon icon={faChevronDown} size="6x" />
    </div>
);

const AccordionComponent = ({
    state: { accordion = [], selectedAccordionIndex = 0 },
    isEditMode,
    focused,
    onChange,
}) => {
    const inStorefront = !window?.location?.pathname.includes("/content/edit/");

    return (
        <>
            {accordion?.length > 0 ? (
                <div
                    data-testid="accordion"
                    className="mx-auto max-w-[960px] rounded-[10px] !border-brand-tertiary bg-brand-white border p-[15px] lg:p-[30px]"
                >
                    {accordion?.map((item, index) => (
                        <Disclosure
                            key={`accordion-${index}`}
                            defaultOpen={item.openByDefault}
                        >
                            {({ open }) => (
                                <div
                                    className={`content__accordion flex flex-col gap-[15px]`}
                                    data-testid={`accordion__item-${index}`}
                                    style={{
                                        boxShadow:
                                            selectedAccordionIndex === index &&
                                            focused &&
                                            "inset 0 0 0 3px yellow",
                                    }}
                                >
                                    <Disclosure.Button
                                        className={`w-full active:border-0 focus:outline-none`}
                                        {...(isEditMode && {
                                            onClick: () => {
                                                onChange({
                                                    selectedAccordionIndex:
                                                        index,
                                                });
                                            },
                                        })}
                                        data-testid={`accordion__item-${index}--header`}
                                    >
                                        <div
                                            className={` text-brand-black flex items-center justify-between`}
                                        >
                                            <span className="font-bold text-[18px] leading-[24px] lg:text-[24px] lg:leading-[30px]">
                                                {item.label}
                                            </span>

                                            <div className="flex items-center justify-center h-[30px] w-[30px] bg-brand-light-grey rounded-full ml-[15px]">
                                                <FontAwesomeIcon
                                                    className="text-[16px] leading-[22px]"
                                                    icon={
                                                        open
                                                            ? faChevronUp
                                                            : faChevronDown
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Disclosure.Button>

                                    <Disclosure.Panel>
                                        <div className={`mb-[15px]`}>
                                            <AccordionContent
                                                content={item.text}
                                            />
                                        </div>
                                    </Disclosure.Panel>
                                </div>
                            )}
                        </Disclosure>
                    ))}
                </div>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </>
    );
};

export default AccordionComponent;
